import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ProjeGorevEditComponent } from './proje-gorev-edit.component';
import { ProjeGorevKartComponent } from './proje-gorev-kart.component';

@DinamikBilesen({
  id: 'proje-gorev',
  baslik: 'Proje Görevi',
  aciklama: 'Proje görevi ekle',
  ikon: 'project',
  kategori: 'proje',
})
class ProjeGorev {
  paylas_kutusu = ProjeGorevEditComponent;
  paylasilmis_kart = ProjeGorevKartComponent;
}
